import { STATUS, NUM_STATUS } from "./statuses";
import { SFIcons } from "@sf-core";

const getStatusBadge = (status, t) => {
  switch (status) {
  case STATUS.IN_PROGRESS:
  case NUM_STATUS.IN_PROGRESS:
    return {
      color: "blue300",
      icon: <SFIcons.SFTimelapseIcon color="grey200" />,
      label: t("lxpComponents.courses.badges.started")
    };
  case STATUS.COMPLETED:
  case NUM_STATUS.COMPLETED:
    return {
      color: "green300",
      icon: <SFIcons.SFCompletedIcon color="grey200" />,
      label: t("lxpComponents.courses.badges.completed")
    };
  case STATUS.NOT_STARTED:
  case NUM_STATUS.NOT_STARTED:
  default:
    return null;
  }
};

export default getStatusBadge;
